import React from 'react';
import styled from 'styled-components';

import { useConsent } from './ConsentContext';

// Styled to sit alongside the footer's NavLinks rather than look like a control.
const LinkButton = styled.button`
  appearance: none;
  background: none;
  border: 0;
  padding: 0;
  font: inherit;
  color: inherit;
  cursor: pointer;

  &:hover {
    text-decoration: underline;
  }
`;

// CPRA and the state laws that followed it require a persistent way to change
// your mind — a banner that disappears after one click does not satisfy it.
// GDPR requires the same: withdrawal must be as easy as giving consent.
const PrivacyChoicesLink: React.FC = () => {
  const { openPreferences } = useConsent();

  return (
    <LinkButton type="button" onClick={openPreferences}>
      Your privacy choices
    </LinkButton>
  );
};

export default PrivacyChoicesLink;
